import { IBoard, IUserActiveItem, IUserDepricated } from "@mctypes/global.types";
import React, { useState } from "react";
import { useCopyToClipboard } from "usehooks-ts";
import { STANDARD_COLORS } from "../../app/globalConstants";
import { IMemberWithDomain } from "../../app/routes/admin/members/memberTypes";
import IssueItemModalMantine from "../../app/routes/issuesApp/IssuesTab/IssueItemModal/new/IssueItemModalMantine";
import Avatar from "../Avatar";
import FoldableSectionDeprecated from "../FoldableSection/FoldableSectionDeprecated";
import "./MemberCard.css";

interface IMemberCardProps {
  member: IMemberWithDomain;
  assignedItems?: IUserActiveItem[];
  projectId: string;
  orgTitle?: string;
}
const MemberCardDepricated: React.FC<IMemberCardProps> = ({ member, assignedItems, projectId, orgTitle }) => {
  const [, copy] = useCopyToClipboard();
  const [activeAssignedItem, setActiveAssignedItem] = useState<IUserActiveItem>(null);

  const infoRows = [
    { label: "tlf", value: (member?.user as IUserDepricated)?.phoneNumber ?? "-" },
    { label: "epost", value: (member?.user as IUserDepricated)?.email ?? "-" },
    { label: "disiplin", value: member?.disciplin ?? "-" },
    { label: "domene", value: member?.domain ?? "-" },
  ];
  const roleColors = {
    ADMIN: STANDARD_COLORS.orange,
    PARTNER: STANDARD_COLORS.green,
    INTERNAL: STANDARD_COLORS.grey,
    CLIENT: STANDARD_COLORS.blue,
  };

  return (
    <>
      <div className="memberCard">
        <div className="d-flex flex-column align-items-center">
          <div style={{ marginRight: "-.5em" }}>
            <Avatar
              id={(member?.user as IUserDepricated)?._id}
              name={(member?.user as IUserDepricated)?.name}
              size="xl"
            />
          </div>
          <h3 className="my-1">{(member?.user as IUserDepricated)?.name}</h3>{" "}
          {orgTitle && <p className="font-weight-bold mb-2">{orgTitle}</p>}
          <div
            className="memberGroupBadge"
            style={{ color: `${roleColors[member?.group]}`, border: `3px solid ${roleColors[member?.group]}` }}
          >
            {member?.group}
          </div>
        </div>
        <div className="infoContainer">
          {infoRows.map((row, i) => (
            <div key={i} className="d-flex  align-items-center rowContainer" style={{ fontSize: "1.1em" }}>
              <div className="rowLabel">{row.label}:</div>
              <div className="rowValue">{row.value}</div>
              <button className="addIcon" onClick={() => copy(row.value)}>
                <i className="fa fa-files-o"></i>
              </button>
            </div>
          ))}
        </div>
        <div className="foldableContainer">
          {assignedItems != null && (
            <FoldableSectionDeprecated folded={true} headerClick={true}>
              <FoldableSectionDeprecated.Header>
                <div className="d-flex align-items-center section-title">
                  Aktive Oppgaver
                  <div
                    className="textCircle ml-2"
                    style={{ fontSize: "0.7em", width: "1.7em", height: "1.7em", marginTop: ".2em" }}
                  >
                    {assignedItems?.length}
                  </div>
                </div>
              </FoldableSectionDeprecated.Header>
              {/* <FoldableSectionDeprecated.Body>
                <div className="d-flex flex-column h-100 mt-2 mb-2 tableContainer ag-theme-quartz">
                  {assignedItems && assignedItems.length > 0 && (
                    <AgGridReact
                      rowData={assignedItems}
                      columnDefs={createActiveAssignedItemsColumns(setActiveAssignedItem)}
                      domLayout="autoHeight"
                      headerHeight={40}
                      defaultColDef={{
                        sortable: false,
                        filter: false,
                        suppressHeaderMenuButton: true,
                        cellStyle: {
                          whiteSpace: "normal",
                          lineHeight: "1.5",
                          wordBreak: "break-word",
                        },
                        autoHeight: true,
                      }}
                      onGridReady={(e) => {
                        e.api.autoSizeColumns(["id", "name", "dueDate", "status"]);
                      }}
                    />
                  )}
                </div>
              </FoldableSectionDeprecated.Body> */}
            </FoldableSectionDeprecated>
          )}
        </div>
      </div>
      {activeAssignedItem && activeAssignedItem.app === "issues" && (
        <IssueItemModalMantine
          itemId={activeAssignedItem.itemId}
          issueBoardId={(activeAssignedItem.board as IBoard)._id}
          projectId={projectId}
          onClose={() => setActiveAssignedItem(null)}
        />
      )}
    </>
  );
};

export default MemberCardDepricated;
